import React, { useState, useEffect, memo } from 'react'
import CardRubro from './cardRubro'
import { useMediaQuery, useTheme } from '@mui/material'
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view'
import { flattenRubrosHierarchy } from '../../../../Products/hooks/rubros.hook'
import { Rubro } from '../../types/rubro'
import { GruposAtributos, MonedaList, UnidadDeMedidaList } from '../../../../Integraciones/types/responses'

interface MultiSelectTreeViewProps {
  searchedRubro?: string | null // Prop para recibir el rubro buscado
  rubros: Rubro[]
  flatRubros: Rubro[]
  monedas: MonedaList[]
  unidadesDeMedida: UnidadDeMedidaList[]
  gruposAtr: GruposAtributos[]
  updateRubros: () => void
  expandedNodes: string[]
  setExpandedNodes: (nodes: string[]) => void
}

const MultiSelectTreeView: React.FC<MultiSelectTreeViewProps> = ({
  searchedRubro,
  rubros,
  flatRubros,
  monedas,
  unidadesDeMedida,
  gruposAtr,
  updateRubros,
  expandedNodes,
  setExpandedNodes
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [matched, setMatched] = useState<string[]>([])

  const handleNodeSelect = (nodeCode: any) => {
    const rubro = flatRubros.find((r) => r.codRubro === nodeCode)

    let expanded = [...expandedNodes]

    if (expandedNodes.includes(nodeCode)) {
      expanded = expanded.filter((code) => code !== nodeCode)
      rubro?.rubros?.map((r: Rubro) => {
        if (expanded.includes(r.codRubro)) {
          expanded = expanded.filter((code) => code !== r.codRubro)
        }
      })
    } else {
      expanded.push(nodeCode)
    }

    setExpandedNodes([...expanded])
  }

  useEffect(() => {
    if (searchedRubro && flatRubros.length > 0) {
      const found = flatRubros
        .filter((r) => r.nombre.toLowerCase().includes(searchedRubro.toLowerCase()))
        .map((r) => r.codRubro)
      setMatched(found)
    } else {
      setMatched([])
    }
  }, [searchedRubro, flatRubros])

  const renderTreeItems = (nodes: Rubro[]) =>
    nodes.map((node: Rubro) => {
      const isNodeMatched = matched.includes(node.codRubro)
      return (
        <TreeItem
          key={node.codRubro}
          itemId={node.codRubro}
          label={
            <div
              //className={`${nodeClasses.nombre}`}
              style={{
                backgroundColor: isNodeMatched ? 'yellow' : 'transparent',
                ...(isNodeMatched && { fontStyle: 'italic' })
              }}
            >
              {node.nombre}
            </div>
          }
          onClick={() => handleNodeSelect(node.codRubro)}
        >
          {expandedNodes.includes(node.codRubro) && (
            <CardRubro
              rubros={flatRubros}
              isMobile={isMobile}
              rubro={node}
              monedas={monedas}
              unidadesDeMedida={unidadesDeMedida}
              gruposAtr={gruposAtr}
              updateRubros={updateRubros}
              handleNodeSelect={handleNodeSelect}
            />
          )}
          {node.rubros && renderTreeItems(node.rubros)}
        </TreeItem>
      )
    })

  return (
    <>
      {rubros.length > 0 && (
        <div style={{ marginLeft: '-22px' }}>
          <SimpleTreeView
            key={JSON.stringify(rubros)}
            //getItemId={(item) => item.codRubro}
            //getItemLabel={(item) => item.nombre}
            //defaultCollapseIcon={<ExpandMore />}
            //defaultExpandIcon={<ChevronRightIcon />}
            //expanded={expandedNodes}
            expandedItems={expandedNodes}
            //items={rubros}
            // eslint-disable-next-line react/no-children-prop
            children={renderTreeItems(rubros)}
            style={{ height: 1000, flexGrow: 1, maxWidth: 1000 }}
          />
        </div>
      )}
    </>
  )
}

export default memo(MultiSelectTreeView)
